import React, {Component} from 'react';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import moment from 'moment';

import Button from 'components/button/button';
import Endpoints from 'helpers/enums/endpoints';
import Hero from 'components/heroes/hero';
import LoaderHelper from 'helpers/utilities/loader-helper';
import MakeHash from 'make-hash';
import Page from 'components/page/page';
import Text from 'components/text/text';
import TextField from 'components/fields/text-field';
import TransitionLink from 'components/transition-link/transition-link';
import messages from './messages';
import { gigyaPasswordReset } from './gigya.js';
import {loadScriptAsync} from "./gigya";

class SetPassword extends Component {
  constructor(props) {
    super(props);

    const { intl } = props;

    this.state = {
      'serverError': false,
      'formMessages': [],
      'loading': false,
    };
  }

  componentDidMount() {
    loadScriptAsync(`https://cdns.gigya.com/js/gigya.js?apikey=${process.env.REACT_APP_GIGYA_KEY}`).then(() => {
      gigyaPasswordReset();
    });
  }


  _renderHero() {
    return (
      <Hero title="Set Password" supportingTxt="Please set a new password for your account." />
    )
  }


  render() {
    const { intl } = this.props;
    const pageHero = this._renderHero();

    return (
      <Page title="Set Password" pageHero={pageHero}>
        <div className="container container_constrainedMd">
          <div className="gigya-screen-set" id="userScreensDiv" />
        </div>
      </Page>
    );
  }
}

export default injectIntl(SetPassword);


// WEBPACK FOOTER //
// ./src/client/pages/auth/set-password.jsx